import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
import AuthClassicLayout from 'src/layouts/auth/classic';
// layouts
import MainLayout from 'src/layouts/main';
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// import InvoiceDownloadPage from 'src/components/trainings/InvoiceDownloadPage';
// ----------------------------------------------------------------------

export const HomePage = lazy(() => import('src/pages/register'));
export const PostRegister = lazy(() => import('src/components/register/post-register'));

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);

const RouterDashboardStore = lazy(() =>
  import('src/pages/newDashboard/routerDashboard').then((module) => ({
    default: module.RouterDashboardStore,
  }))
);

const NewDashboardView = lazy(() => import('src/pages/newDashboard/dashboard'));



// ----------------------------------------------------------------------

export const RouterDashboardRoutes = [
  {
    path: '/',
    element: (
      <AuthGuard allowedRoles={['organization', 'trainee', 'administrator', 'manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <RouterDashboardStore />, index: true },
    ],
  },
];

export const NewDashboardRoutes = [
  {
    path: '/dashboard',
    element: (
      <AuthGuard allowedRoles={['organization', 'manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <NewDashboardView />, index: true },
    ],
  },
  {
    path: '/auth/post/register',
    element: (
      <AuthGuard allowedRoles={['organization', 'manager']}>
        <AuthClassicLayout>
          <PostRegister />
        </AuthClassicLayout>
      </AuthGuard>
    ),
    children: [
      { element: <NewDashboardView />, index: true },
    ],
  },
];

export const PublicRoutes = [
  {
    path: '/auth/register',
    element: (
        <AuthClassicLayout>
          <HomePage />
        </AuthClassicLayout>
    ),
  },  
];


